import { Link } from "react-router-dom";

const labelByDirection = {
  source: "Συνδεδεμενη εφεση",
  derived: "υποθεση εκκαλουμενης αποφασης",
};

const AppealLinks = ({ links = [], compact = false }) => {
  if (!Array.isArray(links) || links.length === 0) {
    return null;
  }

  const visibleLinks = compact ? links.slice(0, 1) : links;
  const hiddenCount = links.length - visibleLinks.length;

  return (
    <section
      className={`appeal-link-panel${
        compact ? " appeal-link-panel--compact" : ""
      }`}
      aria-label="Συνδεδεμένες υποθέσεις"
    >
      {!compact && <h2>Συνδεδεμένες υποθέσεις</h2>}
      <div className="appeal-link-list">
        {visibleLinks.map((link) => (
          <Link
            className="appeal-link-item"
            key={`${link.direction}-${link.id}-${link.linked_case_id}`}
            to={`/cases/${link.linked_case_id}`}
            onClick={(event) => event.stopPropagation()}
          >
            <span className="appeal-link-label">
              {labelByDirection[link.direction] || "Συνδεδεμένη υπόθεση"}
            </span>
            <span className="appeal-link-main">
              ΓΑΚ {link.linked_gak}/{link.linked_year}
            </span>
            {link.linked_court && (
              <span className="appeal-link-court">{link.linked_court}</span>
            )}
            {link.linked_note?.trim() && (
              <span className="appeal-link-note">{link.linked_note}</span>
            )}
          </Link>
        ))}
        {hiddenCount > 0 && (
          <span className="appeal-link-more">
            +{hiddenCount} ακόμη συνδεδεμένες
          </span>
        )}
      </div>
    </section>
  );
};

export default AppealLinks;
